import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from 'lib/api-client';
import { QueryConfig } from 'lib/react-query';
import { ProjectGroup } from 'types/api';
import { env } from 'config/env';
import { http, HttpResponse, delay } from 'msw';

type GetProjectGroupResponse = {
    project_group: ProjectGroup;
};

export const getProjectGroup = async (id: string): Promise<ProjectGroup> => {
    const response = await api.get<
        GetProjectGroupResponse,
        GetProjectGroupResponse
    >(`/app/api/v1/project_group/${id}`);
    return response.project_group;
};

export const getProjectGroupQueryOptions = (id: string) => {
    return queryOptions({
        queryKey: ['project_group', id],
        queryFn: () => getProjectGroup(id),
    });
};

export const getProjectGroupQueryKeysForAllProjectGroups = () => {
    return ['project_group'];
};

type UseProjectGroupOptions = {
    id: string;
    queryConfig?: QueryConfig<typeof getProjectGroupQueryOptions>;
};

export const useProjectGroup = ({
    id,
    queryConfig,
}: UseProjectGroupOptions) => {
    return useQuery({
        ...getProjectGroupQueryOptions(id),
        ...queryConfig,
    });
};

export const getProjectGroupMSWHandler = (projectGroup: ProjectGroup) => {
    return http.get(
        `${env.API_URL}/app/api/v1/project_group/:projectGroupId`,
        async () => {
            await delay(1000);
            return HttpResponse.json({ project_group: projectGroup });
        },
    );
};
